import { render, staticRenderFns } from "./sendMessage.vue?vue&type=template&id=14e6fdbd&scoped=true&"
import script from "./sendMessage.vue?vue&type=script&lang=ts&"
export * from "./sendMessage.vue?vue&type=script&lang=ts&"
import style0 from "./sendMessage.vue?vue&type=style&index=0&id=14e6fdbd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e6fdbd",
  null
  
)

export default component.exports